/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Administrator from './components/administrator/Administrator';

const title = 'Panel Administratora';

export default {

  path: '/administrator',

  action() {
    return {
      title,
      component: <Administrator title={title}></Administrator >,
    };
  },

};


// WEBPACK FOOTER //
// src/routes/administrator/index.js